import { State } from "../Model/State";
export class AuthorizationService {
    constructor(storageKey) {
        this.storageKey = storageKey;
        this.accessTokenVersion = '2';
        this.hasToken = new State(!!this.getToken());
        const tokenVersionKey = `${storageKey}_version`;
        if (this.accessTokenVersion !== localStorage.getItem(tokenVersionKey)) {
            // this.clearToken();
        }
        localStorage.setItem(tokenVersionKey, this.accessTokenVersion);
    }
    setToken(token) {
        localStorage.setItem(this.storageKey, token);
        this.hasToken.set(true);
    }
    getToken() {
        return localStorage.getItem(this.storageKey);
    }
    clearToken() {
        localStorage.removeItem(this.storageKey);
        this.hasToken.set(false);
    }
    subscribe(sub) {
        return this.hasToken.subscribe(sub);
    }
}
